/* Product galleries: navigation stays below the photo; legacy Rover links show one style. */
(function () {
  var root = document.querySelector('[data-gallery]');
  if (!root) return;
  var main = root.querySelector('[data-gallery-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  var prev = root.querySelector('[data-gallery-prev]');
  var next = root.querySelector('[data-gallery-next]');
  var strip = root.querySelector('[data-gallery-thumbs]');
  var controls = root.querySelector('[data-gallery-controls]');
  var live = root.querySelector('[data-gallery-count]');
  if (!main || !thumbs.length) return;
  var active = thumbs;
  var index = 0;
  function show(i) {
    index = (i + active.length) % active.length;
    main.src = active[index].getAttribute('data-src');
    main.alt = main.alt.replace(/image \d+$/, 'image ' + (index + 1));
    thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === active[index])); });
    if (live) live.textContent = (index + 1) + ' / ' + active.length;
  }
  function selectActivity(activity) {
    active = thumbs.filter(function (t) {
      var style = t.getAttribute('data-gallery-activity');
      return !style || style === activity;
    });
    thumbs.forEach(function (t) { t.hidden = active.indexOf(t) < 0; });
    if (strip) strip.hidden = active.length < 2;
    if (controls) controls.hidden = active.length < 2;
    show(0);
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(active.indexOf(t)); }); });
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
  });
  var page = root.closest('[data-product-page]');
  var rover = page && page.querySelector('form[data-handle="heritage-the-rover"] select[name="id"]');
  function updateStyle() {
    var option = rover.options[rover.selectedIndex];
    var activity = option.getAttribute('data-variant-activity');
    selectActivity(activity);
    var activityLabel = page.querySelector('[data-product-activity]');
    if (activityLabel) activityLabel.textContent = activity;
    var price = page.querySelector('.pdp-price');
    if (price && price.firstChild && price.firstChild.nodeType === 3) price.firstChild.textContent = option.getAttribute('data-variant-price') + ' ';
    var url = new URL(window.location.href);
    url.searchParams.set('variant', rover.value);
    window.history.replaceState(null, '', url);
  }
  if (rover) {
    rover.addEventListener('change', updateStyle);
    updateStyle();
  } else selectActivity(null);
})();
